import Translator from "./translate";
import type {
  BatchTranslationResponse,
  DetectTranslationResponse,
  TranslationResponse,
  BatchTranslation,
  TranslateOptions,
} from "@/types";

export type {
  BatchTranslationResponse,
  DetectTranslationResponse,
  TranslationResponse,
  BatchTranslation,
  TranslateOptions,
};
export {Translator};
